module.exports = {"InventoryCountType":{"OutOfOrder":"Ausser Betrieb (OoO)"},"InvoiceMediaType":{"Display":"mit Briefkopf und -fuß","Print":"ohne Briefkopf und -fuß"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de-CH/enums.json
// module id = BJHs
// module chunks = 0